import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundImage: `linear-gradient(${theme.palette.primary.main}, #1a7254)`,
    color: theme.palette.white.neutral,
    fontSize: 15,
    padding: "6px",
    fontWeight: 500,
    borderRight: "1px solid white",
    whiteSpace: "nowrap",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: "6px 10px 6px 6px",
  },
}));

export default StyledTableCell;
